class ShowMore {
    constructor() {
        this._btn = document.getElementsByClassName('js-btn-show-more');
        this._btnTextHide = 'fermer';
        this._btnTextShow = 'en savoir plus';

        this._createListener();
    }

    _createListener() {
        for (let btn of this._btn) {
            btn.addEventListener('click', () => {
                this._toggleShow(btn);
            });
        }
    }

    _toggleShow(btn) {
        let text   = btn.previousElementSibling;
        let toHide = text.querySelector('.js-to-hide');

        if (toHide.offsetHeight === 0) {
            toHide.style.maxHeight = toHide.scrollHeight + 'px';
            btn.innerText = this._btnTextHide;
        } else {
            toHide.style.maxHeight = '';
            btn.innerText = this._btnTextShow;
        }

        btn.parentElement.classList.toggle('open');
    }

}

module.exports = ShowMore;